// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".round[data-v-2343fc10]{width:10px;height:10px;border-radius:50%;background:#fff;border:2px solid #333;position:relative;-webkit-box-sizing:border-box;box-sizing:border-box}.round[data-v-2343fc10]:after{content:\"\";width:2px;height:2px;background:#ff8c00;position:absolute;top:2px;left:2px}", ""]);
// Exports
module.exports = exports;
